// extracted by mini-css-extract-plugin
export var content = "header-module--content--78f2d";
export var links = "header-module--links--53a19";
export var mainheaderecho = "header-module--mainheaderecho--2de71";